import {
  Button,
  HStack,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import { FaTrash } from 'react-icons/fa';
import {
  formatCurrency,
  formatDocument,
  validateDocument,
} from '../helpers/csvValidation';
import { CsvRow } from '../types/nfse.types';

interface CsvPreviewProps {
  data: CsvRow[];
  onClear: () => void;
  invalidDocuments?: Set<string>;
}

const CsvPreview: React.FC<CsvPreviewProps> = ({
  data,
  onClear,
  invalidDocuments = new Set(),
}) => {
  const total = data.reduce(
    (sum, row) =>
      sum +
      (typeof row.value === 'number'
        ? row.value
        : parseFloat(String(row.value)) || 0),
    0,
  );

  return (
    <TableContainer>
      <HStack justify="space-between" mb="1rem">
        <Text fontWeight="medium" color="gray.600">
          {data.length} documento(s) encontrado(s) - Total:{' '}
          {formatCurrency(total)}
        </Text>
        <Button
          size="sm"
          variant="ghost"
          colorScheme="red"
          leftIcon={<FaTrash />}
          onClick={onClear}
        >
          Limpar
        </Button>
      </HStack>

      <Table variant="simple" size="sm">
        <Thead>
          <Tr h="3.5rem">
            <Th textAlign="left" w="200px">
              Documento
            </Th>
            <Th textAlign="center" w="100px">
              Tipo
            </Th>
            <Th textAlign="right" w="150px">
              Valor
            </Th>
          </Tr>
        </Thead>

        <Tbody>
          {data.slice(0, 50).map((row, idx) => {
            const docString = String(row.document);
            const docType = validateDocument(docString);
            const value =
              typeof row.value === 'number'
                ? row.value
                : parseFloat(String(row.value)) || 0;
            const isInvalid = invalidDocuments.has(docString);

            return (
              <Tr
                key={idx}
                bg={isInvalid ? 'red.50' : undefined}
                _hover={{ bg: isInvalid ? 'red.100' : 'gray.50' }}
              >
                <Td color={isInvalid ? 'red.600' : undefined}>
                  {formatDocument(docString)}
                </Td>
                <Td
                  textAlign="center"
                  color={isInvalid ? 'red.600' : undefined}
                >
                  {docType || '-'}
                </Td>
                <Td textAlign="right" color={isInvalid ? 'red.600' : undefined}>
                  {formatCurrency(value)}
                </Td>
              </Tr>
            );
          })}
        </Tbody>
      </Table>

      {data.length > 50 && (
        <Text color="gray.500" fontSize="sm" mt="1rem" textAlign="center">
          Mostrando 50 de {data.length} registros
        </Text>
      )}
    </TableContainer>
  );
};

export default CsvPreview;
